import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  SimpleChange,
  ElementRef,
  AfterViewInit
} from '@angular/core';
import { ITableHeader } from './luci-table.model';
import {TreeFilterPipe} from '../commons/pipes/tree-filter-pipe/tree-filter.pipe';
import { GlobalSearchFilter } from '../commons/pipes/global-search-filter/global-search-filter.pipe';

@Component({
  selector: 'luci-table',
  templateUrl: './luci-table.component.html',
  styleUrls: ['./luci-table.component.scss']
})

export class LuciTableComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() tableHeader: any[] = [];
  @Input() tableData: any[] = [];
  @Input() totalData: any = {};
  @Input() alignText = '';
  @Input() isSortable: boolean;
  @Input() isRowSelect: boolean;
  @Input() isResizable = false;
  @Input() isActionsLeft = false;
  @Input() isActionsRight = false;
  @Input() actionWithIcons = false;
  @Input() isHideColumns = false;
  @Input() isSearchable = false;
  @Input() isPagination = false;
  @Input() noResultsMsg = '';
  @Input() tableType = 'horizontal';
  @Input() isRowClick = false;
  @Input() isDefaultColumn = false;
  @Input() defaultLabel = '';
  @Input() customActionsRight = false;
  @Input() emitTableData = false;
  @Input() isRefreshGrid = false;
  @Input() sortInfo: any = {};
  @Input() paginationPosition = '';
  @Input() paginationSize = 10;
  @Input() editValidation = {};
  @Input() editDropdownData = {};
  @Input() reloadSearch = true;
  @Input() isClone = true;
  @Input() isAllInfo = false;
  @Input() rightActionIcons = false;
  @Input() rightActionEdit = false;
  @Input() disableCallBacks = {};
  @Input() editableCallBacks = null;
  @Input() changeCallBacks = {};
  @Input() resizeHeaderLabel = false;
  @Input() isReArrange = false;
  @Input() isPersonalizationColumns = false;
  @Input() isMultiColumnSorting = false;
  @Input() personalizationColumnsLabel = '';
  @Input() multiColumnSortingLabel = '';
  @Input() isPersonalizationFreeze = false;
  @Input() PersonalizationApplyBtnText = 'Apply';
  @Input() PersonalizationResetBtnText = 'Reset';
  @Input() isDataFetchedFromServer = {};


  // toolbar props
  @Input() exportTypes = '';
  @Input() isSearch = '';
  @Input() isExport = '';
  @Input() isSearchRight = '';
  @Input() isToolbar = '';
  @Input() cstSeparator = '';
  @Input() fileName = '';
  @Input() pdfType = '';
  @Input() isCustomExportIcon = false;
  @Input() toolBarSearchPlaceHolder = 'Search';
  @Input() isDataFetchFromServer = false;
  @Input() isToolbarHideColumns = false;
  @Input() isToolbarFilter = false;
  @Input() isToolbarRefresh = false;
  @Input() isSelect = '';
  @Input() toolbarDropdownOptions = [];
  @Input() selectedOption = '';

  @Input() restoreIcon = 'restore';
  @Input() filterIcon = 'filter';
  @Input() hideColumnsIcon = 'add';
  @Input() sortColumnsIcon = 'sort';
  @Input() customMoveIcon = false;

  @Input() freezeColumns  = [];
  @Input() scrollInfo: any = {};
  @Input() isShowTotal = false;
  @Input() isFreeze = false;
  @Input() isScroll = false;
  @Input() freezeScrollTop = 0;
  @Input() isSearchOpen = false;
  @Input() isHideColumnsButton = false;
  @Input() isBadgeClickable = false;
  @Input() scrollTriggerHeight = '50';

  @Output() updateExport = new EventEmitter();

  @Output() updateLinkDetails = new EventEmitter();
  @Output() updateIconClick = new EventEmitter();
  @Output() rowClickCn = new EventEmitter();
  @Output() emitCustomAction: EventEmitter<any> = new EventEmitter();
  @Output() customizedTableData: EventEmitter<any> = new EventEmitter();
  @Output() onlinkclick = new EventEmitter<any>();
  @Output() refresh = new EventEmitter<any>();
  @Output() resizeCallback  = new EventEmitter();
  @Output() updateFreezeSort = new EventEmitter();
  @Output() updateFreezeSearch = new EventEmitter();
  @Output() rowBadgeClickCallback = new EventEmitter();
  @Output() updateFreezeResize = new EventEmitter();
  @Output() loadMoreData = new EventEmitter();
  @Output() updateDataFetch = new EventEmitter();
  @Output() emitSelectedItem = new EventEmitter();
  @Output() resetPersonalization = new EventEmitter();

  applyAllInfoStyle = true;
  allSelected = false;
  editableRow: any = {};
  sort: any = {
    order: '',
    field: '',
    type: ''
  };
  filteredColumns: any = {};
  showColumns = false;
  search: any = {};
  searchParam: any = [];

  disableUpdateColumnBtn = false;

  tableRowsData: any[] = [];
  dropDownOptions: any = {};
  searchFilter = new TreeFilterPipe();
  tableRows = [];
  isPaginationReset = false;
  globalSearchFilter = new GlobalSearchFilter();
  reArrangeHeaders = [];
  freezeScrollValue  = 0;
  thWidths = {};
  globalSearchQuery = '';
  clickedBadgeDetails = {row: '', column: ''};
  showColumnsModal = false;
  showSortMultiColumnsModal = false;
  dialog = {
    id: '',
    headline: 'Personalize List Columns',
    message: '',
    isForm: false,
    formData: [],
  };
  sortDialog = {
    id: '',
    headline: 'Multi column sorting',
    message: '',
    isForm: false,
    formData: [],
  };

  constructor(private el: ElementRef) {
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    const reloadSearch: SimpleChange = changes.reloadSearch;
    const isResizable: SimpleChange = changes.isResizable;
    if (this.reloadSearch || (reloadSearch && reloadSearch.currentValue)) {
      if (this.isHideColumns && changes.tableHeader && changes.tableHeader.currentValue) {
        this.reArrangeHeaders = [...changes.tableHeader.currentValue];
        this.updateFilterColumns();
      }
      if (changes.tableData && changes.tableData.currentValue && changes.tableData.currentValue.length > 0) {
        this.updateTable();
      }
    }

    if (isResizable) {
      this.createResizable();
    }
    if (changes.freezeScrollTop && this.isFreeze) {
      if ( this.el.nativeElement.querySelectorAll('.no-vertical-scroll-active').length > 0) {
        this.el.nativeElement.querySelectorAll('.no-vertical-scroll-active')[0].querySelector('tbody').scrollTo(0, changes.freezeScrollTop.currentValue);
      }
    }
    if (changes.personalizationColumnsLabel) {
      this.dialog.headline = changes.personalizationColumnsLabel.currentValue;
    }
    if (changes.isDataFetchedFromServer && changes.isDataFetchedFromServer.currentValue) {
       if (changes.isDataFetchedFromServer.currentValue.PesonalizationColumn &&
         changes.isDataFetchedFromServer.currentValue.PesonalizationColumn.success){
         this.showColumnsModal = false;
         this.updatePersonalizationColumns(changes.isDataFetchedFromServer.currentValue.PesonalizationColumn);
       }
       if (changes.isDataFetchedFromServer.currentValue.PesonalizationColumnReset &&
        changes.isDataFetchedFromServer.currentValue.PesonalizationColumnReset.success){
        this.showColumnsModal = false;
        this.tableHeader = changes.isDataFetchedFromServer.currentValue.PesonalizationColumnReset.headers;
        this.createResizable();
      }
    }
    if (changes.multiColumnSortingLabel) {
        this.sortDialog.headline = changes.multiColumnSortingLabel.currentValue;
      }
  }

  ngAfterViewInit() {
     if (this.isScroll && this.scrollInfo.height) {
       const elmId = !this.isFreeze ?  'scroll-table-active' : 'no-vertical-scroll-active';
       if (this.el.nativeElement.querySelectorAll(`.${elmId}`).length > 0 ) {
         this.thWidths = {};
         this.el.nativeElement.querySelectorAll(`.${elmId}`)[0].querySelectorAll('th').forEach(th => {
          // this.thWidths[th.id] = th.clientWidth;
           const style = window.getComputedStyle(th);
           const v = th.offsetWidth -
             parseFloat(style.paddingLeft) -
             parseFloat(style.paddingRight) -
             parseFloat(style.borderLeft) -
             parseFloat(style.borderRight) -
             parseFloat(style.marginLeft) -
             parseFloat(style.marginRight);
           console.log(v);
           this.thWidths[th.id] = v;
         });
       /*  if (this.scrollInfo.width || this.isFreeze) {
           this.el.nativeElement.querySelectorAll(`.${elmId}`)[0].querySelectorAll('th').forEach((th, index) => {
             th.style.width = this.thWidths[index] + 'px';
           });
         }*/
       }
     }
  }

  updateTableContentDom(timeout = 0){
    if (this.isScroll && this.scrollInfo.height) {
      const elmId = !this.isFreeze ? 'scroll-table' : 'no-vertical-scroll';
      if (this.scrollInfo.width || this.isFreeze) {
        setTimeout(() => {
        this.el.nativeElement.querySelectorAll(`.${elmId}`)[0].querySelector('tbody').querySelectorAll('tr').forEach(tr => {
          tr.querySelectorAll('td').forEach((td, index) => {
            td.style.width = this.thWidths[index] + 'px';
          });
        });
        this.el.nativeElement.querySelectorAll(`.${elmId}`)[0].querySelector('thead').querySelectorAll('tr').forEach(tr => {
          tr.querySelectorAll('td').forEach((td, index) => {
            td.style.width = this.thWidths[index] + 'px';
          });
        });
        }, timeout);
      }
    }
  }

  updateSearchRowDom(){
    setTimeout( () => {
      if (this.isScroll && this.scrollInfo.height) {
        const elmId = !this.isFreeze ? 'scroll-table' : 'no-vertical-scroll';
        if (this.scrollInfo.width || this.isFreeze) {
          // tslint:disable-next-line:max-line-length
          this.el.nativeElement.querySelectorAll(`.${elmId}`)[0].querySelector('thead').querySelectorAll('tr')[1].querySelectorAll('th').forEach((th, index) => {
            th.style.width = this.thWidths[index] + 'px';
          });
        }
      }
    });
  }

  updateTable() {
    this.tableRowsData = [];
    this.tableRows = [];
    this.search = {};
    this.searchParam = [];

    // If you want to sort update in ngrx, should maintain prevention of update tableData in parent,
    // this is a shared component and we will emit the sort update event to parent,
    // we wont call  here ngrx related stuff

    // The sort function emits the soretd data to the parent component.
    // That emitted data is stored to ngRx Store. The data chages in the ngRx store invokes the onchages method
    // which inturn will call the updateTable method.... which make it an infinite loop.
    if (this.isSortable && this.sortInfo && !this.isDataFetchFromServer) {
      this.sort.order = this.sortInfo.order === 'asc' ? 'dsc' : 'asc';
      this.sortColumn(this.sortInfo.field, this.sortInfo.type, true);
    }
    this.tableData.forEach((t: any) => {
      const obj: any = { ...t };
      this.tableRowsData.push(obj);
      this.tableRows.push(obj);
    });
    this.updateDropdownList();
  }

  updatePage(pageInfo) {
    setTimeout(() => {
      this.tableData = [...this.tableRowsData.slice(pageInfo.startIndex, pageInfo.endIndex + 1)];
      this.isPaginationReset = false;
    });
  }

  updateIconAction(row, type) {
    this.updateIconClick.emit({ row, type });
  }

  rowSelect(event, row, index) {
    const changedRow = { ...row };
    const tableData = [...this.tableData];
    changedRow.selected = event.target.checked;
    const updatedTableRow = tableData.map((tableRow, key) => {
      if (tableRow.id === changedRow.id) {
        tableRow.selected = changedRow.selected;
      }
      return tableRow;
    });
    this.allSelected = updatedTableRow.every(eachRow => eachRow.selected === true);
    if (this.emitTableData) {
      this.customizedTableData.emit({ type: 'select', rowData: updatedTableRow, rowIndex: index });
    }
  }

  selectAll(event) {
    this.tableData.map(data => data.selected = event.target.checked);
    if (this.emitTableData) {
      this.customizedTableData.emit({ type: 'selectAll', rowData: this.tableData });
    }
  }

  selectDefaultRow(event, row, index) {
    const changedRow = { ...row };
    const tableData = [...this.tableData];
    changedRow.default = event.target.checked;
    const updatedTableRow = tableData.map((tableRow, key) => {
      if (tableRow.id === changedRow.id) {
        tableRow.default = changedRow.default;
      } else {
        tableRow.default = !changedRow.default;
      }
      return tableRow;
    });

    if (this.emitTableData) {
      this.customizedTableData.emit({ type: 'default', rowData: updatedTableRow, rowIndex: index });
    }
  }

  sortColumn(field, type, flag, header?) {
    if (!flag && (!this.isSortable || !header.sortable)){
      return;
    }
    if (!flag && this.isFreeze) {
      this.updateFreezeSort.emit({field,  type});
      return;
    }
    let sortedData = [];
    this.search = {};
    this.searchParam = [];
    if (!this.sort.order || this.sort.order === 'dsc') {
      this.sort.order = 'asc';
    } else {
      this.sort.order = 'dsc';
    }
    this.sort.field = field;
    if (this.isDataFetchFromServer) {
      this.updateDataFetch.emit({type: 'Sort', query: { sortInfo: this.sort } });
    } else {
      const tableRows = flag ? [...this.tableData] : this.tableRows;
      sortedData = tableRows.sort((a: any, b: any) => {
        if (type === 'date') {
          let date1: any = null;
          let date2: any = null;
          date1 = (a[field]) ? new Date(a[field].slice(0, a[field].length - 3)) : null;
          date2 = (b[field]) ? new Date(b[field].slice(0, b[field].length - 3)) : null;
          if (date1 === date2) {
            return 0;
          } else if (date1 === null) {
            return 1;
          } else if (date2 === null) {
            return -1;
          } else if (this.sort.order === 'asc') {
            return date1 < date2 ? -1 : 1;
          } else {
            return date1 < date2 ? 1 : -1;
          }
        } else if (type === 'string' || type === 'bind') {
          const fieldA = (a[field]) ? a[field].toLowerCase() : null;
          const fieldB = (b[field]) ? b[field].toLowerCase() : null;
          const dateString: any = a[field] ? new Date(a[field].slice(0, a[field].length - 3)) : null;
          if (fieldA === fieldB) {
            return 0;
          } else if (!(isNaN(fieldA) && !isNaN(Date.parse(dateString)))) {
            // string  number
            if (!(isNaN(fieldA))) {
              if (this.sort.order === 'asc') {
                return a[field] - b[field];
              } else {
                return b[field] - a[field];
              }
            } else {
              if (fieldA === null) {
                return 1;
              } else if (fieldB === null) {
                return -1;
              } else if (this.sort.order === 'asc') {
                return fieldA < fieldB ? -1 : 1;
              } else {
                return fieldA < fieldB ? 1 : -1;
              }
            }
          } else {
            // string date
            const date3: any = a[field] ? new Date(a[field].slice(0, a[field].length - 3)) : null;
            const date4: any = a[field] ? new Date(b[field].slice(0, b[field].length - 3)) : null;
            if (date3 === date4) {
              return 0;
            } else if (date3 === null) {
              return 1;
            } else if (date4 === null) {
              return -1;
            } else if (this.sort.order === 'asc') {
              return date3 < date4 ? -1 : 1;
            } else {
              return date3 < date4 ? 1 : -1;
            }
          }
        } else if (type === 'link') {
          const fieldA = a[field];
          const fieldB = b[field];
          const linkDateString: any = a[field] ? new Date(a[field].slice(0, a[field].length - 3)) : null;
          if (fieldA === fieldB) {
            return 0;
          } else if (!(isNaN(fieldA) && !isNaN(Date.parse(linkDateString)))) {
            // link number and string
            if (!(isNaN(fieldA))) {
              if (this.sort.order === 'asc') {
                return a[field] - b[field];
              } else {
                return b[field] - a[field];
              }
            } else {
              const fieldA1 = a[field] ? a[field].toLowerCase() : null;
              const fieldB1 = b[field] ? b[field].toLowerCase() : null;
              if (fieldA1 === null) {
                return 1;
              } else if (fieldB1 === null) {
                return -1;
              } else if (this.sort.order === 'asc') {
                return fieldA1 !== fieldB1 ? fieldA1 < fieldB1 ? -1 : 1 : 0;
              } else {
                return fieldA1 !== fieldB1 ? fieldA1 > fieldB1 ? -1 : 1 : 0;
              }
            }

          } else {
            // link date
            const date1: any = a[field] ? new Date(a[field].slice(0, a[field].length - 3)) : null;
            const date2: any = a[field] ? new Date(b[field].slice(0, b[field].length - 3)) : null;
            if (date1 === date2) {
              return 0;
            } else if (date1 === null) {
              return 1;
            } else if (date2 === null) {
              return -1;
            } else if (this.sort.order === 'asc') {
              return date1 < date2 ? -1 : 1;
            } else {
              return date1 < date2 ? 1 : -1;
            }
          }
        } else {
          if (this.sort.order === 'asc') {
            return a[field] - b[field];
          } else {
            return b[field] - a[field];
          }
        }
      });

      if (!flag && this.isPagination) {
        if (sortedData.length < this.paginationSize) {
          this.tableRowsData = [...sortedData];
          this.noResultsMsg = '';
          this.updatePage({startIndex: 0, endIndex: sortedData.length - 1});
        } else {
          this.tableRowsData = [...sortedData];
          this.isPaginationReset = true;
        }
      } else {
        this.tableData = [...sortedData];
      }

      // This is emit the changed data back to the parent component.
      if (this.emitTableData && !flag) {
        this.customizedTableData.emit({type: 'sort', rowData: sortedData});
      }
    }
  }


  editRow(row, index) {
    row.showActions = false;
    this.editableRow[row.id] = { ...row };
    row.editable = true;
  }

  deleteRow(row, index) {
    row.showActions = false;
    let rowIndex = 0;
    this.tableRows.forEach((t, i) => {
      if (t.id === row.id) {
        rowIndex = i;
      }
    });
    this.tableRows.splice(rowIndex, 1);
    if (this.tableRows.length < this.paginationSize) {
      this.tableRowsData = [...this.tableRows];
      this.isPaginationReset = false;
      this.noResultsMsg = '';
      this.updatePage({ startIndex: 0, endIndex: this.tableRows.length - 1 });
    } else {
      this.tableRowsData = [...this.tableRows];
      this.isPaginationReset = true;
    }
    this.customizedTableData.emit({ type: 'edit', rowData: this.tableRows , row });
  }

  cloneRow(row, index) {
    let rowIndex = 0;
    this.tableRows.forEach((t, i) => {
      if (t.id === row.id) {
        rowIndex = i;
      }
    });
    row.showActions = false;
    const r = { ...row };
    r.id = Math.max.apply(Math, this.tableRows.map((t) => t.id)) + 1;
    this.tableRows.splice(rowIndex, 0, r);
    if (this.tableRows.length < this.paginationSize) {
      this.tableRowsData = [...this.tableRows];
      this.isPaginationReset = false;
      this.noResultsMsg = '';
      this.updatePage({ startIndex: 0, endIndex: this.tableRows.length - 1 });
    } else {
      this.tableRowsData = [...this.tableRows];
      this.isPaginationReset = true;
    }
    this.customizedTableData.emit({ type: 'edit', rowData: this.tableRows });
  }

  updateChanges(row) {
    const modifiedData = [];
    this.tableRows.forEach((r) => {
      if (row.id === r.id) {
        modifiedData.push(row);
      } else {
        modifiedData.push(r);
      }
    });
    this.customizedTableData.emit({ type: 'edit', rowData: [...modifiedData], row });
    this.tableRows = [...modifiedData];
  }

  isUpdateDisable(row) {
    let isDisable = false;
    Object.keys(this.editValidation).forEach(e => {
      isDisable = row[e] === '' ? true : isDisable;
      if (this.disableCallBacks[e]) {
        isDisable = this.disableCallBacks[e]({key: e}, row) ? false : isDisable;
      }
    });
    return isDisable;
  }

  emitAction(event, row) {
    if (event) {
      this.emitCustomAction.emit({ event, row });
    }
  }

  preventDefalut(event) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }

  cancelChanges(row, index) {
    row.editable = false;
    this.tableData[index] = this.editableRow[row.id];
  }

  updateColumns() {
    this.showColumns = false;
    const headers: ITableHeader[] = [...this.reArrangeHeaders];
    headers.forEach((h: ITableHeader) => {
      if (this.filteredColumns.hasOwnProperty(h.key)) {
        h.headerDisplay = this.filteredColumns[h.key];
      }
    });
    this.tableHeader = [...headers];
    this.createResizable();
    if (this.isDataFetchFromServer) {
      this.updateDataFetch.emit({type: 'column-personalization', query: {headers: this.tableHeader}});
    }
  }

  createResizable() {
    if (this.isResizable) {
      this.isResizable = false;
      setTimeout(() => this.isResizable = true, 100);
    }
  }

  updateGlobalSearch(searchQuery){
    this.globalSearchQuery = searchQuery;
    this.sort = {
      order: '',
      field: '',
      type: ''
    };
    if (this.isDataFetchFromServer) {
      this.updateDataFetch.emit({type: 'Global Search', query: { searchQuery :  this.globalSearchQuery } });
    } else {
      const searchedItems = this.globalSearchFilter.transform(this.tableRows, searchQuery);
      this.searchCallback(searchedItems);
    }
  }

  updateSelectedItem(selectedItem){
    this.emitSelectedItem.emit(selectedItem);
  }

  clearSearch() {
    if (this.isSearchOpen) {
      return;
    }
    this.search = {};
    this.searchParam = [];
    if (this.isDataFetchFromServer) {
      this.updateDataFetch.emit({type: 'Clear Search', query: { searchQuery :  this.globalSearchQuery,
          searchParam :  this.searchParam, search:  this.search } });
    } else {
      let searchedItems = [...this.tableRows];
      if (this.globalSearchQuery) {
        searchedItems = this.globalSearchFilter.transform(this.tableRows, this.globalSearchQuery);
      }
      this.searchCallback(searchedItems);
    }
  }

  searchCallback(searchedItems) {
    if (this.isPagination) {
      if (searchedItems.length < this.paginationSize) {
        this.tableRowsData = [...searchedItems];
        this.noResultsMsg = '';
        this.updatePage({ startIndex: 0, endIndex: searchedItems.length - 1 });
      } else {
        this.tableRowsData = [...searchedItems];
        this.isPaginationReset = true;
      }
    } else {
      this.tableData = [...searchedItems];
    }
  }

  updateRowBadgeClick(row, h) {
      this.clickedBadgeDetails.row = row.id;
      this.clickedBadgeDetails.column = h.key;
      if (this.isBadgeClickable) {
        this.rowBadgeClickCallback.emit({row , h});
      }
  }

  updateSearch($event, key: string) {
    if (this.isFreeze) {
      this.updateFreezeSearch.emit({$event, key});
      return;
    }
    const params = [...this.searchParam];
    this.search[key] = $event;
    if (params.indexOf(key) > -1) {
      params.splice(params.indexOf(key), 1);
      if ($event) {
        params.push(key);
      }
    } else {
      params.push(key);
    }
    this.searchParam = [...params];
    this.sort = {
      order: '',
      field: '',
      type: ''
    };
    if (this.isDataFetchFromServer) {
      this.updateDataFetch.emit({type: 'search', query: {searchParam :  this.searchParam, search:  this.search } });
    } else {
      const searchedItems = this.searchFilter.transform(this.tableRows, this.searchParam, this.search);
      this.searchCallback(searchedItems);
      this.updateDropdownList();
    }
  }

  updateResize(data) {
    if (this.isFreeze) {
      this.updateFreezeResize.emit(data);
      return;
    }
    let headers = [...this.tableHeader];
    headers =  headers.map((h: any) => {
          const obj: any = {...h};
          if (obj.key === data.id) {
          obj.width = data.width;
          }
          return obj;
      });
    this.tableHeader = [...headers];
    this.createResizable();
    this.resizeCallback.emit({header: data,  headers: this.tableHeader});
  }

  goToLink(row, type, value, index) {
    this.updateLinkDetails.emit({ row, type, value, index });
  }

  onlinkClick(key, value, row) {
    this.onlinkclick.emit({
      field: { key, value },
      row
    });
  }

  rowOnClick(row) {
    if (row.target && row.target.innerText === 'All Info') {
      this.applyAllInfoStyle = true;
    } else {
      this.applyAllInfoStyle = false;
    }
    if (this.isRowClick) {
      this.tableData.forEach((r) => {
        r.clicked = false;
      });
      row.clicked = true;
      this.rowClickCn.emit(row);
    }
  }

  disableHideButton() {
    let displayHeaderCount = 0;
    this.tableHeader.forEach((h: ITableHeader) => {
      if (this.filteredColumns.hasOwnProperty(h.key)) {
        displayHeaderCount = this.filteredColumns[h.key] ? displayHeaderCount + 1 : displayHeaderCount;
      } else {
        displayHeaderCount += 1;
      }
    });
    this.disableUpdateColumnBtn = displayHeaderCount < 3;
  }
  resetColumns() {
    this.tableHeader.forEach((h: ITableHeader) => {
      this.filteredColumns[h.key] = true;
    });
    this.reArrangeHeaders = this.reArrangeHeaders.sort((h1, h2) => {
      return h1.id - h2.id;
    });
    this.disableUpdateColumnBtn = false;
  }

  updateFilterColumns() {
    this.tableHeader.forEach((h: ITableHeader) => {
      this.filteredColumns[h.key] = h.headerDisplay;
    });
  }

  refreshGrid() {
    this.search = {};
    this.searchParam = [];
    this.refresh.emit();
  }

  updateDropdownList() {
    if (this.tableHeader && this.tableRows) {
      const tableRows = this.isSearchOpen  && (this.searchParam.length > 0  ||
        this.isFreeze) ?  [...this.tableData] : [...this.tableRows];
      this.tableHeader.forEach((h: any) => {
        /// this.search[h.key] = '';
        if (h.selectedType === 'combo') {
          const arrangedData = tableRows.reduce((res, o) => {
            const obj = {
              name: o[h.key],
              value: o[h.key]
            };

            return res.findIndex(k => k.name === o[h.key]) < 0 ? [...res, obj] : res;
          }, []);

          const sotedData = arrangedData.sort((a, b) => {
            if (a.name === ' ' || a.name === '' || a.name === null) { return 1; }
            if (b.name === ' ' || b.name === '' || b.name === null) { return -1; }
            if (a.name === b.name) { return 0; }
            return a.name < b.name ? -1 : 1;
          });
          this.dropDownOptions[h.key] = sotedData;
        }
      });
    }
  }

  getIsDisable(h, row) {
    if (this.disableCallBacks[h.key]) {
      return this.disableCallBacks[h.key](h, row);
    } else if (h.hasOwnProperty('editable')) {
      return !h.editable;
    } else {
      return false;
    }
  }

  isEditable(row) {
    if (this.editableCallBacks) {
      return this.editableCallBacks(row);
    }
    return  true;
  }

  changeCallback(h, row) {
    if (this.changeCallBacks[h.key]) {
      this.changeCallBacks[h.key](row);
    }
  }

  onHeaderDrop(event , header){
    const headers = [...this.reArrangeHeaders];
    const modifiedHeaders = [];
    headers.forEach((h) => {
      if (h.id === event.dragData.id) {
        modifiedHeaders.push(header);
      } else if (h.id === header.id) {
        modifiedHeaders.push(event.dragData);
      } else {
        modifiedHeaders.push(h);
      }
    });
    this.reArrangeHeaders = [...modifiedHeaders];
  }

  getIcon(icon) {
    return `assets/icons/luci.svg#${icon}`;
  }
  getColSum(key) {
     let sum = 0;
     this.tableData.forEach(r => {
       sum += r[key] ? Number(r[key]) : 0;
     });
     return sum;
  }

  updateScroll($event) {
   if (this.freezeColumns.length > 0) {
     this.freezeScrollValue = $event.target.scrollTop;
   }

   if ($event.currentTarget.scrollTop > (Number(this.scrollTriggerHeight) / 100) * $event.currentTarget.scrollHeight) {
        this.loadMoreData.emit($event.currentTarget.rows.length);
   }
  }

  openShowHideColumns(){
    if (this.isPersonalizationColumns) {
     this.showColumnsModal = !this.showColumnsModal;
    } else {
       this.showColumns = !this.showColumns;
    }
  }
  resetHeader(event) {
    if (event) {
      if (this.isDataFetchFromServer) {
        this.updateDataFetch.emit({type: 'column-personalization', query: {...event}});
      } else {
        this.showColumnsModal = false;
        this.updatePersonalizationColumns(event);
      }
     } else {
      this.showColumnsModal = false;
    }
  }
  resetSettings() {
    this.resetPersonalization.emit();
  }

  openSortMultiColumns(){
    if (this.isMultiColumnSorting) {
     this.showSortMultiColumnsModal = !this.showSortMultiColumnsModal;
    } else {
       this.showSortMultiColumnsModal = !this.showSortMultiColumnsModal;
    }
  }

  updatePersonalizationColumns(event){
    this.tableHeader = event.headers;
    if (event.isFreeze) {
      const previousFreezeColumns = this.freezeColumns.filter(h => h.key !== event.key);
      this.freezeColumns = [event.headers[event.index], previousFreezeColumns];
    }
    this.createResizable();
  }

  multiColumnSortConfig(event) {

    console.log(event, this.sortInfo);
  }
}
